import React from "react";
import { SVGProps } from "react";

interface LocalIconProps extends SVGProps<SVGSVGElement> {
  primaryColor?: string;
  secondaryColor?: string;
  tertiaryColor?: string;
}

const LocalIcon: React.FC<LocalIconProps> = ({
  primaryColor = "#4059ad",
  secondaryColor = "#00856D",
  tertiaryColor = "#e05263",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={422}
    height={87}
    viewBox="0 0 422 87"
    fill="none"
    {...props}
  >
    <path
      fill="#191501"
      fillRule="evenodd"
      d="M106.91 65.14c11.952 0 21.64-9.688 21.64-21.64 0-11.951-9.688-21.64-21.64-21.64-11.951 0-21.64 9.689-21.64 21.64 0 11.952 9.689 21.64 21.64 21.64Zm0 21.64c23.903 0 43.281-19.377 43.281-43.28 0-23.903-19.378-43.28-43.281-43.28S63.63 19.597 63.63 43.5c0 23.903 19.377 43.28 43.28 43.28ZM306.929 65.14c11.952 0 21.641-9.688 21.641-21.64 0-11.951-9.689-21.64-21.641-21.64-11.951 0-21.64 9.689-21.64 21.64 0 11.952 9.689 21.64 21.64 21.64Zm0 21.64c23.903 0 43.281-19.377 43.281-43.28 0-23.903-19.378-43.28-43.281-43.28s-43.28 19.377-43.28 43.28c0 23.903 19.377 43.28 43.28 43.28Z"
      clipRule="evenodd"
    />
    <path
      fill="#191501"
      d="M366.389 2.384c0-1.195.969-2.164 2.164-2.164h17.312c1.196 0 2.164.969 2.164 2.164V86.78h-19.476a2.164 2.164 0 0 1-2.164-2.163V2.383Z"
    />
    <path
      fill="#191501"
      fillRule="evenodd"
      d="M368.553.22a2.164 2.164 0 0 0-2.164 2.164v82.233c0 1.195.969 2.163 2.164 2.163h19.476V2.384A2.163 2.163 0 0 0 385.865.22h-17.312Z"
      clipRule="evenodd"
    />
    <path
      fill="#191501"
      d="M419.644 65.14c1.195 0 2.164.97 2.164 2.164v17.312a2.164 2.164 0 0 1-2.164 2.164h-31.615V65.14h31.615Z"
    />
    <path
      fill="#191501"
      fillRule="evenodd"
      d="M421.808 67.304a2.164 2.164 0 0 0-2.164-2.164h-31.615v21.64h31.615a2.164 2.164 0 0 0 2.164-2.164V67.304Z"
      clipRule="evenodd"
    />
    <path
      fill="#191501"
      d="m350.213 43.5-.007 41.11-13.509-.242L350.213 43.5Z"
    />
    <path
      fill="#191501"
      fillRule="evenodd"
      d="m336.697 84.368 13.509.242.007-41.11-13.516 40.868Z"
      clipRule="evenodd"
    />
    <path
      fill="#191501"
      d="M.67 2.384C.67 1.189 1.639.22 2.834.22h17.312c1.195 0 2.164.969 2.164 2.164V86.78H2.834A2.164 2.164 0 0 1 .67 84.618V2.383Z"
    />
    <path
      fill="#191501"
      fillRule="evenodd"
      d="M2.834.22A2.164 2.164 0 0 0 .67 2.384v82.233c0 1.195.969 2.163 2.164 2.163H22.31V2.384A2.164 2.164 0 0 0 20.146.22H2.834Z"
      clipRule="evenodd"
    />
    <path
      fill="#191501"
      d="M53.925 65.14c1.196 0 2.164.97 2.164 2.164v17.312a2.164 2.164 0 0 1-2.164 2.164H22.31V65.14h31.615Z"
    />
    <path
      fill="#191501"
      fillRule="evenodd"
      d="M56.09 67.304a2.164 2.164 0 0 0-2.165-2.164H22.31v21.64h31.615a2.164 2.164 0 0 0 2.164-2.164V67.304Z"
      clipRule="evenodd"
    />
    <path
      fill="#191501"
      d="M227.878 48.91c-2.402 9.334-10.875 16.23-20.958 16.23-11.952 0-21.641-9.688-21.641-21.64 0-11.951 9.689-21.64 21.641-21.64 10.083 0 18.556 6.896 20.958 16.23h19.537c1.301 0 2.312-1.143 2.078-2.423C245.807 15.503 228.148.22 206.92.22c-23.903 0-43.281 19.377-43.281 43.28 0 23.903 19.378 43.28 43.281 43.28 21.228 0 38.887-15.283 42.573-35.447.234-1.28-.777-2.423-2.078-2.423h-19.537ZM306.929 86.78c19.406-16.458 43.277-33.868 43.277-2.17a2.164 2.164 0 0 1-2.164 2.164l-41.113.006Z"
    />
    <path
      fill="#191501"
      fillRule="evenodd"
      d="m306.929 86.78 41.113-.006a2.164 2.164 0 0 0 2.164-2.164c0-31.698-23.871-14.288-43.277 2.17Z"
      clipRule="evenodd"
    />

    <circle cx="107" cy="43.5" r="22" fill={secondaryColor} />
    <circle cx="306.929" cy="43.5" r="22" fill={primaryColor} />
  </svg>
);

export default LocalIcon;
